import React from 'react';

export default function FertilityEnhancingSurgery() {
  return (
    <main className="section-container py-12">
      <div className="space-y-8">
        <section>
          <h1 className="text-4xl font-bold text-brand mb-6">
            Fertility Enhancing Laparoscopic & Hysteroscopic Surgery
          </h1>
          <p className="text-lg text-neutral/70 leading-relaxed">
            Laparoscopy Surgery and hysteroscopy is a very important part of evaluation as well as treatment in infertility. They enable us to 'see and treat' at the same sitting. If undertaken timely by a trained fertility specialist, this procedure can help most couples conceive naturally even without treatment. Even in couples who need assisted reproduction (IUI/IVF or ICSI) there is big role of laparoscopy and hysteroscopy to improve results of these treatments.
          </p>
        </section>
        <section>
          <p className="text-lg text-neutral/70 leading-relaxed">
            Laparoscopy is done with a thin telescope, which is just 4 mm thick. This is inserted through the belly button under anesthesia. We examine the reproductive organs using a 3 chip HD camera (Karl Storz) which provides excellent resolution and magnification. We are able to diagnose tubal blocks, adhesions (abnormal sticking of organs to each other), conditions like endometriosis, infections like pelvic tuberculosis, fibroids etc Hysteroscopy is the process of visualizing the inner lining of the uterus with a thin telescope (only 1.9 mm) . In hysteroscopy, we can diagnose fibroids, adhesions, polyps and infections of endometrium.
          </p>
        </section>
        <section>
          <p className="text-lg text-neutral/70 leading-relaxed">
            Both laparoscopy and hysteroscopy are usually done together and they are complementary, providing a complete assessment of the reproductive organs. The procedure is painless and is done under general anesthesia and is usually a day care procedure. The patient can return to daily activities in two or three days and usually no stitches are required.
          </p>
        </section>
        <section>
          <p className="text-lg text-neutral/70 leading-relaxed">
            The beauty of laparoscopy is that most of problems that have been diagnosed can be treated at the same sitting. For example, almost 60% of tubal blocks can be treated at the same sitting and tubal patency can be restored. This enables the couples to conceive normally without IVF. Dr. Priya Bhave Chittawar is the best laparoscopic surgeon in Bhopal for Laparoscopic Surgery.
          </p>
        </section>
      </div>
    </main>
  );
}
